import { put, select, takeLatest } from 'redux-saga/effects'

import {
  editRiderSumAssured,
  editRiderSelectedPlan,
  updateSelectedPlan,
} from 'quick-quote/product-common/coverage-plan/actions'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'

import { SELECT_HEALTH_TOPPING_PLAN } from './actions'

export function createProductHealthToppingFunc() {
  const selectHealthToppingPlan = function*(action) {
    const selectedPlanCode = action.payload
    const displayProduct = yield select(getSelectedDisplayProduct)
    const plans = displayProduct.plans

    const selectedPlan = plans.find((v) => v.planCode === selectedPlanCode)
    if (selectedPlan) {
      yield put(updateSelectedPlan(selectedPlanCode))
      const selectedPlan = plans.find((v) => v.planCode === selectedPlanCode)
      for (let rider of selectedPlan.riders) {
        yield put(editRiderSumAssured(rider.code, 0))
        yield put(editRiderSelectedPlan(rider.code, rider))
      }
    }
  }

  return {
    selectHealthToppingPlan,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { HEALTH_TOPPING } = serviceWrapper.products
  yield [takeLatest([SELECT_HEALTH_TOPPING_PLAN], HEALTH_TOPPING.onUpdateSelectedBasicPlan)]
}

export const sagas = watchers
